// extracted by mini-css-extract-plugin
export var confirmationHeader = "_x0-0";
export var confirmationIcon = "_x0-1";